module.exports = __webpack_public_path__ + "static/10400556_21565062223_9863_n-405864ad8d55ba2f9e1d29792ea4f4e1.jpg";